import {
  useMemo,
  useState,
  useEffect,
  useCallback,
  useContext,
  useRef,
} from "react";
import { createPortal } from "react-dom";
import "./Map.css";
import {
  GoogleMap,
  useLoadScript,
  StandaloneSearchBox,
  DirectionsRenderer,
} from "@react-google-maps/api";
import { MarkerClusterer } from "@react-google-maps/api";
import axios from "axios";
import SearchBar from "./SearchBar";
import CMMarker from "./CMMarker";
//import LocationDetail from "./LocationDetail";
import MarkerLocationDetail from "./MarkerLocationDetail";
import markerOther from "../../image/balloon__0.png";
import markerGreen from "../../image/balloon_green.png";
import markerBlue from "../../image/balloon_blue.png";
import markerOrange from "../../image/balloon_orange.png";
import markerRed from "../../image/balloon_red.png";
import Direction from "./Direction";
import RoutePlanner from "./RoutePlanner";
import LocationFilters from "./LocationFilters";
import WhatAreYourThoughts from "./WhatAreYourThoughts";
import Disclaimer from "./Disclaimer";
import Mapkey from "./MapKey";
import VehicleSegment from "./VehicleSegment";
import { LinearProgress, Modal, Paper, Portal, IconButton, Tooltip, Box } from "@mui/material";
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import Filter from "./Filter";
import ChargerListPanel from "./ChargerListPanel";
import { Context } from "../../context";
import {
  sleep,
  resetRoutes,
  networkFilterList,
  socketTypeList,
} from "../../util/Display";
import { useDebounce } from "../../hooks/useDebounce";
import debounce from "lodash/debounce";
import isEmpty from "lodash/isEmpty";
import { MuiDrawer } from "../@material-extend";
import { TripPlanner } from "../create-trip";
import Constant from "../../util/constants";
import { CMFooter } from "../common/CMFooter";
import { useDomainConfig } from "../../hooks/useDomainConfig";
import { GetIconSrc } from "../../util/providerIcons";

const libraries = ["places"];
const { googleMap, socketType, connectorStatus, chargerStatus } = Constant;

export default function Home() {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyB5VfSNqyhjYLoiXpI94yp5H2TPBgOVitY",
    libraries,
  });

  if (!isLoaded) return <div>Loading...</div>;
  return <Map />;
}

function Map() {
  const domainConfig = useDomainConfig();
  const clusterSvg = `${process.env.PUBLIC_URL}/${domainConfig.clusterSvgName}.svg`;
  const domain = domainConfig?.domain.toLowerCase();

  const elRefs = useRef({ waypoints: [] });
  const options = useMemo(
    () => ({
      disabledDefaultUI: true,
      clickableIcons: false,
    }),
    []
  );
  const { maps, message } = useContext(Context);
  const [cmMap, setCmMap] = useState(null);
  const [isMounted, setIsMounted] = useState(false);
  const [locations, setLocation] = useState([]);
  const [searchBox, setSearchBox] = useState([]);
  const [defaultCenter, setDefaultCenter] = useState({
    lat: 28.6314512,
    lng: 77.2166672,
  });
  const center = useMemo(() => defaultCenter, [defaultCenter]);
  const [markerClickLocation, setMarkerClickLocation] = useState("");
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [isDirectionOpen, setIsDirectionOpen] = useState(false);
  const [mapDirection, setMapDirection] = useState();
  const [loading, setLoading] = useState(!1);
  const [showDrawer, setShowDrawer] = useState(false);
  const [filterOpen, setFilterOpen] = useState(false);
  const [networkFilters, setNetworkFilter] = useState([]);
  const [fetchedNetworkFilters, setFetchedNetworkFilters] = useState(false);
  const [networkFilterNameArr, setNetworkFilterNameArr] = useState({});
  const [fsElement, setFsElement] = useState(null);
  const [showChargerList, setShowChargerList] = useState(false);

  // Removed legacy unstable fsControlDiv Google Layout interceptor

  const [mapFilter, setMapFilter] = useState({
    access: [], //"RESIDENTIAL","ALLDAY"
    minLat: null,
    minLng: null,
    maxLat: null,
    maxLng: null,
    polyline: "",
    segment2Wheeler: true,
    segment3Wheeler: true,
    segment4Wheeler: true,
    segmentSwipe: true,
    power1: false,
    power2: false,
    power3: false,
    power4: false,
    connector1: false,
    connector2: false,
    connector3: false,
    connector4: false,
    connector5: false,
    connector6: false,
    connector7: false,
  });

  const debounceFilter = useDebounce(mapFilter, 500);
  const [polyline, setPolyline] = useState("");
  const onLoad = (ref) => {
    setSearchBox(ref);
  };

  const onPlacesChanged = () => {
    const {
      google: {
        maps: { Marker },
      },
      mapInstance,
    } = window;
    if (searchBox) {
      let places = searchBox.getPlaces();
      let place = places[0].geometry.location;
      const position = { lat: place.lat(), lng: place.lng() };
      setDefaultCenter(position);
      if (mapDirection) {
        resetRoutes();
        setPolyline("");
      }

      window.searchMarkerInstance = new Marker({
        map: mapInstance,
        position,
      });
      maps.setMapsData({
        destination: searchBox,
      });
    }
  };

  // Keep search bar and autocomplete visible in Fullscreen mode 
  useEffect(() => {
    let observer = null;

    const handleFullscreenChange = () => {
      const fullscreenElement = document.fullscreenElement || document.webkitFullscreenElement;
      setFsElement(fullscreenElement || null);
      
      if (fullscreenElement) {
        // Handle Google's vanilla JS autocomplete dropdown
        setTimeout(() => {
          const movePacContainers = () => {
            document.querySelectorAll('.pac-container').forEach(pac => {
              if (pac.parentNode !== fullscreenElement) {
                fullscreenElement.appendChild(pac);
              }
            });
          };

          movePacContainers();
          // Watch for autocomplete items added to DOM
          observer = new MutationObserver(() => {
            movePacContainers();
          });
          observer.observe(document.body, { childList: true, subtree: true });

        }, 50);
      } else {
        if (observer) {
          observer.disconnect();
          observer = null;
        }

        const movePacContainersBack = () => {
          document.querySelectorAll('.pac-container').forEach(pac => {
            if (pac.parentNode !== document.body) {
              document.body.appendChild(pac);
            }
          });
        };
        setTimeout(movePacContainersBack, 50);
      }
    };
    
    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    
    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
      if (observer) observer.disconnect();
    };
  }, []);

  const handleFullscreenToggle = () => {
    if (!document.fullscreenElement) {
      document.querySelector('.map-container')?.requestFullscreen().catch(err => {
        console.error(`Error attempting to enable fullscreen: ${err.message}`);
      });
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
  };

  const _getSegmentFilter = () => {
    let segmentFilters = [];
    if (mapFilter && mapFilter.segment2Wheeler) {
      segmentFilters.push(2);
    }
    if (mapFilter && mapFilter.segment3Wheeler) {
      segmentFilters.push(3);
    }
    if (mapFilter && mapFilter.segment4Wheeler) {
      segmentFilters.push(4);
    }
    if (mapFilter && mapFilter.segmentSwipe) {
      segmentFilters.push(5);
    }
    return segmentFilters;
  };

  const _getPowerFilter = () => {
    let powerFilters = [];
    if (mapFilter && mapFilter.power1) {
      powerFilters.push(1);
    }
    if (mapFilter && mapFilter.power2) {
      powerFilters.push(2);
    }
    if (mapFilter && mapFilter.power3) {
      powerFilters.push(3);
    }
    if (mapFilter && mapFilter.power4) {
      powerFilters.push(4);
    }
    return powerFilters;
  };

  const _getConnectorFilter = () => {
    let allConnectorType = socketTypeList.map(({ id }) => id);
    console.log(allConnectorType);
    console.log(mapFilter);
    let selectedConnectors = Object.entries(mapFilter).reduce(
      (connectorsArr, [key, isSelected]) => {
        const matchingSocket = socketTypeList.find(
          (socket) => socket.value === key
        );

        if (isSelected === true && matchingSocket) {
          connectorsArr.push(matchingSocket.id);
        }
        return connectorsArr;
      },
      []
    );
    return selectedConnectors;
  };
  const _getNetworkProviderFilter = () => {
    let allProviders = Object.keys(networkFilterNameArr);
    let selectedProviders = Object.entries(mapFilter).reduce(
      (networkProviders, [key, value]) => {
        if (allProviders.includes(key) && value === true) {
          networkProviders.push(key);
        }
        return networkProviders;
      },
      []
    );
    console.log("Selected Providers:", selectedProviders);
    return selectedProviders;
  };

  const _fetchLocation = debounce((params = null) => {
    let baseUrl = `${process.env.REACT_APP_API_END_POINT}v2/location/get`;
    let accessFilter = mapFilter.access.join();
    let segmentFilter = _getSegmentFilter().join();
    let powerFilter = _getPowerFilter().join();
    let connectorFilter = _getConnectorFilter();
    let selectedProviders = _getNetworkProviderFilter();
    
    // console.log(`[Map] Fetching locations with filters:`, {
    //   baseUrl,
    //   accessFilter,
    //   segmentFilter,
    //   powerFilter,
    //   connectorFilter,
    //   selectedProviders,
    //   mapBounds: {
    //     minLat: mapFilter.minLat,
    //     minLng: mapFilter.minLng,
    //     maxLat: mapFilter.maxLat,
    //     maxLng: mapFilter.maxLng
    //   }
    // });

    if (
      mapFilter.minLat &&
      mapFilter.minLng &&
      mapFilter.maxLat &&
      mapFilter.maxLng
    ) {
      (async function () {
        try {
          setLoading(!0);
          const fetchLocation = async () => {
            let response = await axios(`${baseUrl}`, {
              method: "post",
              data: {
                access: accessFilter,
                segment: segmentFilter,
                minLat: mapFilter.minLat,
                minLng: mapFilter.minLng,
                maxLat: mapFilter.maxLat,
                maxLng: mapFilter.maxLng,
                polyline: polyline,
                provider: selectedProviders,
                // ...(params ? {
                power: powerFilter,
                connector: connectorFilter,
                // }: {
                //   ...params
                // })
              },
            });
            
            // console.log(`[Map] Location API Response:`, {
            //   status: response.status,
            //   dataLength: response.data?.data?.length || 0,
            //   hasData: !!response.data,
            //   hasDataData: !!(response.data && response.data.data)
            // });
            
            // localStorage.setItem('mapsData', JSON.stringify(response.data.data));
            return response.data.data;
          };

          const locations = await fetchLocation();
          // console.log(`[Map] Setting ${locations?.length || 0} locations on map`);
          setLocation(locations);
          setLoading(!1);
        } catch (error) {
          // console.error(`[Map] Error fetching locations:`, error);
          // console.error(`[Map] Location fetch error details:`, {
          //   message: error.message,
          //   status: error.response?.status,
          //   data: error.response?.data
          // });
          setLoading(!1);
        }
      })();
    }
  }, 500);

  const applyFilter = (filterName, value, element) => {
    filterName &&
      setMapFilter((prevFilter) => ({
        ...prevFilter,
        [filterName]: element.target.checked,
      }));
  };

  const applyLocationFilter = (filters) => {
    let newMapFilter = { ...mapFilter, ...filters };
    setMapFilter(newMapFilter);
  };

  const handleMarkerClick = debounce(async (loc) => {
    marketLocationDetail();
    await sleep(300);
    setSelectedLocation(loc);
    setMarkerClickLocation("onMarker");
  }, 500);

  const marketLocationDetail = () => {
    setMarkerClickLocation("");
  };

  /**
   * Add map reference for further use
   * @param {*} map
   * @returns
   */
  const onMapLoad = useCallback((map) => {
    if (!map) {
      return;
    }
    window.mapInstance = map;
    setCmMap(map);
  }, []);

  /**
   * Get min/max lat/lng from map and load only that data
   * @param {*} i
   * @returns
   */
  const onMapIdle = useCallback(
    (i) => {
      if (!cmMap) {
        return;
      }
      let ne = cmMap.getBounds().getNorthEast();
      let sw = cmMap.getBounds().getSouthWest();
      let newFilter = {
        ...mapFilter,
        minLat: sw.lat(),
        minLng: sw.lng(),
        maxLat: ne.lat(),
        maxLng: ne.lng(),
      };
      if (mapFilter.minLat != sw.lat() || mapFilter.minLng != sw.lng()) {
        setMapFilter({
          ...mapFilter,
          minLat: sw.lat(),
          minLng: sw.lng(),
          maxLat: ne.lat(),
          maxLng: ne.lng(),
        });
      }
      if (cmMap.tilesloading) {
        //_fetchLocation();
      }
    },
    [cmMap, mapFilter]
  );

  const exampleMapStyles = [
    { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#242f3e" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
    {
      featureType: "administrative.locality",
      elementType: "labels.text.fill",
      stylers: [{ color: "#9ca5b3" }],
    },
    {
      featureType: "poi",
      elementType: "labels.text.fill",
      stylers: [{ color: "#9ca5b3", visibility: "off" }],
    },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [{ color: "#263c3f" }],
    },
    {
      featureType: "poi.park",
      elementType: "labels.text.fill",
      stylers: [{ color: "#6b9a76" }],
    },
    {
      featureType: "road",
      elementType: "geometry",
      stylers: [{ color: "#38414e" }],
    },
    {
      featureType: "road",
      elementType: "geometry.stroke",
      stylers: [{ color: "#212a37" }],
    },
    {
      featureType: "road",
      elementType: "labels.text.fill",
      stylers: [{ color: "#9ca5b3" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry",
      stylers: [{ color: "#746855" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [{ color: "#1f2835" }],
    },
    {
      featureType: "road.highway",
      elementType: "labels.text.fill",
      stylers: [{ color: "#f3d19c" }],
    },
    {
      featureType: "transit",
      elementType: "geometry",
      stylers: [{ color: "#2f3948", visibility: "false" }],
    },
    {
      featureType: "transit.station",
      elementType: "labels.text.fill",
      stylers: [{ color: "#9ca5b3", visibility: "false" }],
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [{ color: "#17263c" }],
    },
    {
      featureType: "water",
      elementType: "labels.text.fill",
      stylers: [{ color: "#515c6d" }],
    },
    {
      featureType: "water",
      elementType: "labels.text.stroke",
      stylers: [{ color: "#17263c" }],
    },
    {
      featureType: "poi",
      stylers: [{ visibility: "off" }],
    },
  ];

  const toggleDirection = (isOpen) => {
    setIsDirectionOpen(isOpen);
  };

  const toggleDrawer = () => {
    const isShow = !showDrawer;
    const { history, location } = window;
    const url = new URL(location.href);
    if (!isShow) {
      resetRoutes(!1);
      setPolyline("");
    }

    if (url.searchParams.has("tripId") && showDrawer) {
      history.replaceState(null, null, url.origin + url.pathname);
    }

    setShowDrawer(!showDrawer);
  };

  const setWayPoints = (waypoint, remove) => {
    let waypoints = [...elRefs.current.waypoints];
    if (isEmpty(waypoint)) {
      waypoints.length = 0;
    }

    if (!isEmpty(waypoint) && !remove) {
      Array.isArray(waypoint)
        ? (waypoints = [...waypoint])
        : waypoints.push(waypoint);
    }

    if (!isEmpty(waypoint) && remove) {
      waypoints = waypoints.filter((way) => {
        const {
          location: { lat, lng },
        } = way;
        const { location } = waypoint;
        return (
          lat().toPrecision(5) !== location.lat().toPrecision(5) &&
          lng().toPrecision(5) !== location.lng().toPrecision(5)
        );
      });
    }
    return waypoints;
  };

  useEffect(() => {
    const fetchInitialLocation = async () => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            console.log("Initial accurate position:", position.coords);
            setDefaultCenter({
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            });
          },
          (err) => {
            console.error("Initial location fetch failed:", err);
            if (domainConfig.domain.toLowerCase() === "avvtech") {
              setDefaultCenter({ lat: 43.65107, lng: -79.347015 });
            } else {
              setDefaultCenter({ lat: 28.6139, lng: 77.209 });
            }
          },
          {
            enableHighAccuracy: true,
            timeout: 15000,
            maximumAge: 0,
          }
        );
      }
    };
  
    fetchInitialLocation();
  }, []);
  
  // useEffect(() => {
  //   let watchId;

  //   if (navigator.geolocation) {
  //     watchId = navigator.geolocation.watchPosition(
  //       (position) => {
  //         console.log("Updated position:", position.coords);
  //         setDefaultCenter({
  //           lat: position.coords.latitude,
  //           lng: position.coords.longitude,
  //         });
  //       },
  //       (err) => {
  //         console.error("Watch position failed:", err);
  //         if (domainConfig.domain.toLowerCase() === "avvtech") {
  //           setDefaultCenter({
  //             lat: 43.65107,
  //             lng: -79.347015,
  //           });
  //         } else {
  //           setDefaultCenter({
  //             lat: 28.6139,
  //             lng: 77.209,
  //           });
  //         }
  //       },
  //       {
  //         enableHighAccuracy: true,
  //         timeout: 10000,
  //         maximumAge: 0,
  //       }
  //     );
  //   }

  //   return () => {
  //     if (watchId) navigator.geolocation.clearWatch(watchId);
  //   };
  // }, []);

  useEffect(() => {
    _fetchLocation();

    // Set up polling to refresh map markers automatically every 30 seconds.
    // The debounceFilter maintains the current map bounds and filters
    // so it naturally only fetches Chargers visible in the viewport.
    const intervalId = setInterval(() => {
      _fetchLocation();
    }, 30000);

    return () => clearInterval(intervalId);
  }, [debounceFilter]);

  useEffect(() => setIsMounted(true), []);

  useEffect(() => {
    const _fetchNetworkFilters = async () => {
      let url = `${process.env.REACT_APP_API_END_POINT}v2/location/get-provider/${domain}`;
      // console.log(`[Map] Fetching network filters from: ${url}`);

      try {
        const response = await axios.get(url);
        // console.log(`[Map] API Response Status: ${response.status}`);
        // console.log(`[Map] API Response Data:`, response.data);
        
        if (response.status === 200) {
          let fetchedNetworksObj;
          let updatedNetworkArr;
          
          // Check if response.data.data exists and is an array
          if (response.data && response.data.data && Array.isArray(response.data.data) && response.data.data.length > 0) {
            // console.log(`[Map] Processing ${response.data.data.length} network filters`);
            // console.log(`[Map] Available providers:`, response.data.data.map(p => p.name));
            fetchedNetworksObj = response.data.data.reduce(
              (fetchedNetworks, network) => ({
                ...fetchedNetworks,
                [network.name]: false,
              }),
              {}
            );
            updatedNetworkArr = response.data.data;
            // .reduce(
            //   (updatedNetworkArr, network) => {
            //     let updatedNetworkObj = { ...network };
            //     if (
            //       networkFilterList.find(
            //         (filter) => filter.name === network.name
            //       )
            //     ) {
            //       updatedNetworkObj = {
            //         ...updatedNetworkObj,
            //         src: networkFilterList.find(
            //           (filter) => filter.name === network.name
            //         ).src,
            //       };
            //     } else {
            //       updatedNetworkObj = {
            //         ...updatedNetworkObj,
            //         src: networkFilterList.find(
            //           (filter) => filter.name === "Generic"
            //         ).src,
            //       };
            //     }
            //     updatedNetworkArr = [...updatedNetworkArr, updatedNetworkObj];
            //     return updatedNetworkArr;
            //   },
            //   []
            // );
            setNetworkFilterNameArr({ ...fetchedNetworksObj });
            setMapFilter({ ...mapFilter, ...fetchedNetworksObj });
            setNetworkFilter(updatedNetworkArr);
          } else {
            console.warn(`[Map] No network filters data found. Response structure:`, {
              hasData: !!response.data,
              hasDataData: !!(response.data && response.data.data),
              isArray: !!(response.data && response.data.data && Array.isArray(response.data.data)),
              length: response.data && response.data.data ? response.data.data.length : 'N/A'
            });
          }
          setFetchedNetworkFilters(true);
        } else {
          console.warn(`[Map] API returned non-200 status: ${response.status}`);
        }
      } catch (error) {
        // console.error(`[Map] Error fetching network filters:`, error);
        // console.error(`[Map] Error details:`, {
        //   message: error.message,
        //   status: error.response?.status,
        //   data: error.response?.data
        // });
        
        // Fallback to old API if new API fails
        // console.log(`[Map] Attempting fallback to old get-provider API`);
        try {
          const fallbackUrl = `${process.env.REACT_APP_API_END_POINT}v2/location/get-provider`;
          const fallbackResponse = await axios.get(fallbackUrl);
          // console.log(`[Map] Fallback API Response:`, fallbackResponse.data);
          
          if (fallbackResponse.status === 200 && fallbackResponse.data && fallbackResponse.data.data && Array.isArray(fallbackResponse.data.data)) {
            // console.log(`[Map] Using fallback data with ${fallbackResponse.data.data.length} network filters`);
            const fetchedNetworksObj = fallbackResponse.data.data.reduce(
              (fetchedNetworks, network) => ({
                ...fetchedNetworks,
                [network.name]: false,
              }),
              {}
            );
            setNetworkFilterNameArr({ ...fetchedNetworksObj });
            setMapFilter({ ...mapFilter, ...fetchedNetworksObj });
            setNetworkFilter(fallbackResponse.data.data);
            setFetchedNetworkFilters(true);
          }
        } catch (fallbackError) {
          // console.error(`[Map] Fallback API also failed:`, fallbackError);
          setFetchedNetworkFilters(true); // Set to true to prevent infinite retries
        }
      }
    };
    if (!fetchedNetworkFilters) _fetchNetworkFilters();
  }, [fetchedNetworkFilters, mapFilter]);

  const _fetchLocationOnRoute = (polyRes) => {
    if (polyRes && polyRes.routes[0] && polyRes.routes[0].overview_path) {
      let overviewPath = polyRes.routes[0].overview_path;
      if (overviewPath.length > 0) {
        let paths = [];
        for (let i = 0; i < overviewPath.length; i++) {
          paths.push(overviewPath[i].lat());
          paths.push(overviewPath[i].lng());
        }
        setPolyline(paths.join());
      }
    }
  };

  const getDirectionHandler = useCallback(
    (start, end, waypoint = {}, waypointRemove = false) => {
      if (!start || !end) return;
      const { DirectionsService, UnitSystem } = window.google.maps;
      const service = new DirectionsService();
      elRefs.current.waypoints = setWayPoints(waypoint, waypointRemove);

      service.route(
        {
          origin: start,
          destination: end,
          waypoints: elRefs.current.waypoints,
          optimizeWaypoints: true,
          unitSystem: UnitSystem.METRIC,
          travelMode: "DRIVING",
        },
        (result, status) => {
          setMapDirection((p) => undefined);
          const { DistanceMatrixElementStatus } = window.google.maps;
          const { markerClustererInstance } = window;
          if (status === DistanceMatrixElementStatus.OK && result) {
            const { searchBarRef } = elRefs.current;
            setMapDirection(result);
            maps.mapsData.next && maps.mapsData.next.call(this);
            maps.setMapsData({
              loading: !1,
            });
            searchBarRef && (searchBarRef.value = "");
            if (result) {
              setLocation([]);
              window.clustererPrevMaxZoom =
                markerClustererInstance.getMaxZoom();
              markerClustererInstance.setMaxZoom(1);
              markerClustererInstance.repaint();
              !showDrawer && toggleDrawer();
              _fetchLocationOnRoute(result);
            }
          }

          if (status === DistanceMatrixElementStatus.ZERO_RESULTS) {
            const { setMessageOption } = message;
            maps.setMapsData((prev) => ({
              ...prev,
              loading: !1,
            }));
            setMessageOption((prev) => ({
              ...prev,
              open: !0,
              variant: "info",
              message: Constant.message.NO_ROUTE_BETWEEN_LOCATION,
            }));
          }
        }
      );
    },
    [maps, mapDirection, showDrawer]
  );

  // Helper function to check if a charger has valid provider data
  const hasValidProvider = useCallback((location) => {
    if (!location?.provider || !networkFilters || !Array.isArray(networkFilters)) {
      return false;
    }
    
    const provider = location.provider === Constant.domainProviderList["chargemiles"]
      ? domainConfig.provider
      : location.provider;
    
    // Check if provider exists in networkFilters
    const networkProvider = networkFilters.find(network => network.name === provider);
    const genericProvider = networkFilters.find(network => network.name === "GENERIC");
    
    return !!(networkProvider || genericProvider);
  }, [networkFilters, domainConfig]);

  const mapMarkers = useCallback(
    (clusterer) => {
      // Filter locations to only show those with valid provider data
      const validLocations = locations.filter(loc => {
        const isValid = hasValidProvider(loc);
        // if (!isValid) {
        //   console.log(`[Map] Filtering out location ${loc?.name} - no valid provider data for ${loc?.provider}`);
        // }
        return isValid;
      });
      
      const filteredCount = locations.length - validLocations.length;
      //console.log(`[Map] Displaying ${validLocations.length} out of ${locations.length} locations (filtered by provider data)`);
      // if (filteredCount > 0) {
      //   console.log(`[Map] Filtered out ${filteredCount} locations due to missing provider data`);
      // }
      // Group locations by siteId so all chargers within the same charging site
      // show as a single pin. Fall back to lat/lng for locations without a siteId.
      const siteGroups = {};
      validLocations.forEach(loc => {
        const key = (loc.siteId && loc.siteId.trim())
          ? `site_${loc.siteId.trim()}`
          : `latlng_${loc.latitude}_${loc.longitude}`;
        if (!siteGroups[key]) {
          // Create a copy so we don't mutate the original state
          siteGroups[key] = {
            ...loc,
            devices: [...(loc.devices || [])],
            _groupedIds: [loc.party_id ? loc.id : loc._id],
          };
        } else {
          // Merge devices from this charger into the representative marker
          const representative = siteGroups[key];
          if (loc.devices && loc.devices.length > 0) {
            representative.devices = [
              ...representative.devices,
              ...loc.devices,
            ];
          }
          representative._groupedIds.push(loc.party_id ? loc.id : loc._id);
        }
      });
      const siteLocations = Object.values(siteGroups);

      return siteLocations.map((loc, index) => {
        let deviceAvailable;
        if (loc.devices && loc.devices.length) {
          const { stations, status } = loc.devices[0];
          if (status && chargerStatus.includes(status)) {
            const isAnyStationInUse =
              stations && stations.length
                ? stations.find(({ status: stationStatus }) =>
                    [...connectorStatus.inUse, "IN USE", "IN_USE"].some(
                      (s) => s.toUpperCase() === (stationStatus || "").toUpperCase()
                    )
                  )
                : false;

            const isAnyStationAvailable =
              stations && stations.length
                ? stations.find(({ status: stationStatus }) =>
                    connectorStatus.available.some(
                      (s) => s.toUpperCase() === (stationStatus || "").toUpperCase()
                    )
                  )
                : false;
                
            if (status === "Active" && isAnyStationInUse) deviceAvailable = "O";
            else if (status === "Active" && isAnyStationAvailable) deviceAvailable = "A";
            else deviceAvailable = "NA";
          } else deviceAvailable = "U";
        }
        const hasPartyId = loc?.party_id;
        
        // Add error handling for GetIconSrc
        let iconSrc;
        try {
          iconSrc = GetIconSrc({
            location: loc,
            networkFilters,
            deviceAvailable,
          });
        } catch (error) {
          // console.error(`[Map] Error getting icon for location ${loc?.name}:`, error);
          iconSrc = '/logo/amikCharge.jpg'; // Default fallback
        }
        
        // Ensure iconSrc is valid
        if (!iconSrc) {
          // console.warn(`[Map] Invalid iconSrc for location ${loc?.name}, using default`);
          iconSrc = '/logo/amikCharge.jpg';
        }
        
        const icon = {
          url: iconSrc,
          scaledSize: new window.google.maps.Size(55, 55),
        };
        return (
          <CMMarker
            clusterer={clusterer}
            position={{ lat: loc.latitude, lng: loc.longitude }}
            name={loc.name}
            icon={icon}
            // icon={
            //   loc.chargingType === "swapping"
            //     ? markerRed
            //     : loc.segments.includes(2)
            //     ? markerGreen
            //     : loc.segments.includes(3)
            //     ? markerBlue
            //     : loc.segments.includes(4)
            //     ? markerOrange
            //     : markerOther
            // }
            onClick={() => handleMarkerClick(loc)}
            location={loc}
            key={hasPartyId ? loc.id : loc._id}
            isThirdPartyCPO={hasPartyId}
            onDirectionHandler={getDirectionHandler}
          />
        );
      });
    },
    [locations, hasValidProvider, networkFilters, handleMarkerClick, getDirectionHandler, domainConfig]
  );
  return (
    <>
      <div className="map-container" style={{ position: 'relative' }}>
        <GoogleMap
          zoom={googleMap.DEFAULT_ZOOM}
          options={{
            minZoom: googleMap.MIN_ZOOM,
            maxZoom: googleMap.DEFAULT_ZOOM + 3,
            streetViewControl: false,
            mapTypeControl: false,
            mapStyle: false,
            fullscreenControl: false,
            zoomControlOptions: {
              position: window.google?.maps?.ControlPosition?.RIGHT_BOTTOM,
            },
          }}
          center={center}
          mapContainerStyle={{ width: '100%', height: '100%' }}
          onLoad={onMapLoad}
        onIdle={onMapIdle}
      >
        {isMounted && (
          <MarkerClusterer
            onLoad={(clustrer) => (window.markerClustererInstance = clustrer)}
            options={{
              styles: [
                {
                  url: clusterSvg,
                  height: 53,
                  lineHeight: 53,
                  width: 53,
                },
                {
                  url: clusterSvg,
                  height: 56,
                  lineHeight: 56,
                  width: 56,
                },
                {
                  url: clusterSvg,
                  height: 66,
                  lineHeight: 66,
                  width: 66,
                },
                {
                  url: clusterSvg,
                  height: 78,
                  lineHeight: 78,
                  width: 78,
                },
                {
                  url: clusterSvg,
                  height: 90,
                  lineHeight: 90,
                  width: 90,
                },
              ],
              batchSize: 100,
              maxZoom: googleMap.CLUSTER_DEFAULT_MAX_ZOOM,
              minimumClusterSize: 1,
            }}
          >
            {mapMarkers}
          </MarkerClusterer>
        )}
        <Portal disablePortal={!fsElement} container={fsElement}>
          <div className="Map-toolbar">
            {loading && <LinearProgress />}
            <StandaloneSearchBox
              onLoad={onLoad}
              onPlacesChanged={onPlacesChanged}
            >
              <SearchBar
                applyFilter={applyFilter}
                toggleDirection={toggleDirection}
                mapFilter={mapFilter}
                filterOpen={filterOpen}
                setFilterOpen={setFilterOpen}
                isDirectionOpen={isDirectionOpen}
                setCenter={setDefaultCenter}
                onDirectionHandler={getDirectionHandler}
                ref={(elRef) => (elRefs.current.searchBarRef = elRef)}
                onFilter={applyLocationFilter}
                loading={loading}
                networkFiltersArr={networkFilters}
                areNetworkFiltersFetched={fetchedNetworkFilters}
                fsContainer={fsElement || document.body}
                onFavouriteClick={(loc) => {
                  if (loc.latitude && loc.longitude) {
                    const position = { lat: loc.latitude, lng: loc.longitude };
                    if (window.mapInstance) {
                      window.mapInstance.panTo(position);
                      window.mapInstance.setZoom(googleMap.DEFAULT_ZOOM + 3);
                    }
                    setDefaultCenter(position);
                  }
                  handleMarkerClick(loc);
                }}
              />
            </StandaloneSearchBox>
            {/* <VehicleSegment onFilter={applyFilter} data={mapFilter} /> */}
            <RoutePlanner
              onDirectionHandler={getDirectionHandler}
              onToggleDirection={toggleDirection}
              isDirectionOpen={isDirectionOpen}
              fsContainer={fsElement || document.body}
            />
            {/* <Mapkey /> */}
          </div>
        </Portal>
        <Modal key={fsElement ? 'fs' : 'body'} container={fsElement || document.body} open={filterOpen} onClose={() => setFilterOpen(false)} BackdropProps={{ invisible: true }}>
          <Paper
            elevation={8}
            sx={{
              position: 'fixed',
              top: '80px',
              left: '16px',
              margin: '8px 0',
              zIndex: 1100,
              borderRadius: '8px',
              overflow: 'auto',
              maxHeight: 'calc(100vh - 104px)',
            }}
          >
            <Filter
              isMapPage={true}
              applyFilter={applyFilter}
              mapFilter={mapFilter}
              toggleDirection={toggleDirection}
              onRequestClose={() => setFilterOpen(false)}
              onDirectionHandler={getDirectionHandler}
              onFavouriteClick={(loc) => {
                if (loc.latitude && loc.longitude) {
                  const position = { lat: loc.latitude, lng: loc.longitude };
                  if (window.mapInstance) {
                    window.mapInstance.panTo(position);
                    window.mapInstance.setZoom(Constant.googleMap.DEFAULT_ZOOM + 3);
                  }
                  setDefaultCenter(position);
                }
                handleMarkerClick(loc);
              }}
            />
          </Paper>
        </Modal>
        <div id="marker-selector"></div>
        {/* <div className="feedback">
          <WhatAreYourThoughts />
        </div> */}
        {/* <div className="feedback">
          <Disclaimer />
        </div> */}
        <Portal disablePortal={!fsElement} container={fsElement}>
        {markerClickLocation === "onMarker" && (
          <MarkerLocationDetail
            selectedLocation={selectedLocation}
            marketLocationDetail={marketLocationDetail}
            onDirectionHandler={getDirectionHandler}
            map={cmMap}
            networkFiltersArr={networkFilters}
          />
        )}
        </Portal>
        <Portal disablePortal={!fsElement} container={fsElement}>
        <MuiDrawer
          key={fsElement ? 'fs' : 'body'}
          anchor={Constant.action.LEFT}
          open={showDrawer}
          toggleDrawer={toggleDrawer}
          className="trip-planner"
          closeToolTipText="Close Trip Planner"
          hideBackdrop={true}
          variant="persistent"
          ModalProps={{ container: fsElement || document.body }}
        >
          <TripPlanner
            route={mapDirection}
            onDirectionHandler={getDirectionHandler}
          />
        </MuiDrawer>
        </Portal>
        <DirectionsRenderer
          directions={mapDirection}
          onLoad={(renderer) => (window.directionRendererInstance = renderer)}
          options={{
            polylineOptions: {
              zIndex: 50,
              strokeColor: "#6bcfe8",
              strokeWeight: 5,
            },
          }}
        />
        
        {/* Custom controls: Fullscreen toggle + Charger list button */}
        <Box
          sx={{
            position: 'absolute',
            bottom: '80px',
            right: '10px',
            zIndex: 1000,
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
          }}
        >
          <Tooltip title="Show charger list" placement="left">
            <Paper
              elevation={2}
              sx={{
                width: '40px',
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '2px',
                backgroundColor: showChargerList ? 'var(--app-color, #1976d2)' : 'white',
              }}
            >
              <IconButton
                onClick={() => setShowChargerList((prev) => !prev)}
                sx={{
                  padding: '8px',
                  color: showChargerList ? 'white' : '#666',
                  '&:hover': {
                    color: showChargerList ? 'white' : '#333',
                    backgroundColor: showChargerList ? 'var(--app-color, #1976d2)' : '#f4f4f4',
                  },
                }}
              >
                <FormatListBulletedIcon />
              </IconButton>
            </Paper>
          </Tooltip>
          <Tooltip title={fsElement ? "Exit full screen" : "Toggle full screen"} placement="left">
            <Paper
              elevation={2}
              sx={{
                width: '40px',
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '2px',
                backgroundColor: 'white',
              }}
            >
              <IconButton
                onClick={handleFullscreenToggle}
                sx={{
                  padding: '8px',
                  color: '#666',
                  '&:hover': {
                    color: '#333',
                    backgroundColor: '#f4f4f4',
                  }
                }}
              >
                {fsElement ? <FullscreenExitIcon /> : <FullscreenIcon />}
              </IconButton>
            </Paper>
          </Tooltip>
        </Box>
        {/* Charger list panel */}
        {showChargerList && (
          <Portal disablePortal={!fsElement} container={fsElement}>
            <ChargerListPanel
              locations={locations}
              networkFilters={networkFilters}
              onChargerClick={(loc) => {
                if (loc.latitude && loc.longitude) {
                  window.mapInstance?.panTo({ lat: loc.latitude, lng: loc.longitude });
                  window.mapInstance?.setZoom(Constant.googleMap.DEFAULT_ZOOM + 3);
                }
                handleMarkerClick(loc);
                setShowChargerList(false);
              }}
              onClose={() => setShowChargerList(false)}
            />
          </Portal>
        )}
      </GoogleMap>
      </div>
      {/* <CMFooter /> */}
    </>
  );
}
